const modernStructure = [
    {
        key: '1',
        small: 100,
        big: 200,
        duration: 20,
    },
    {
        key: '2',
        small: 200,
        big: 400,
        duration: 20,
    },
    {
        key: '3',
        small: 300,
        big: 600,
        duration: 20,
    },
    {
        key: '4',
        small: 500,
        big: 1000,
        duration: 20,
    },
    {
        key: '5',
        small: 800,
        big: 1600,
        duration: 20,
    },
    {
        key: '6',
        small: 1200,
        big: 2400,
        duration: 20,
    },
    {
        key: '7',
        small: 2000,
        big: 4000,
        duration: 20,
    },
    {
        key: '8',
        small: 3000,
        big: 6000,
        duration: 20,
    },
    {
        key: '9',
        small: 5000,
        big: 10000,
        duration: 20,
    },
    {
        key: '10',
        small: 8000,
        big: 16000,
        duration: 20,
    },
    {
        key: '11',
        small: 12000,
        big: 24000,
        duration: 20,
    },
    {
        key: '12',
        small: 20000,
        big: 40000,
        duration: 20,
    },
    {
        key: '13',
        small: 30000,
        big: 60000,
        duration: 20,
    },
    {
        key: '14',
        small: 50000,
        big: 100000,
        duration: 20,
    },
    {
        key: '15',
        small: 80000,
        big: 160000,
        duration: 20,
    }
]

export default modernStructure;
